import React from 'react';
import { useTranslation } from 'react-i18next';
import MobileLayout from '../../components/mobile/MobileLayout';
import { textParagraphs } from '../../lib/publicContent';
import { ed, usePageMeta } from '../../lib/editTexts';
import { PRIVACY_PROCESSING_KEYS } from '../../lib/editKeys';

const Section = ({ num, titleKey, children }) => {
  const { t } = useTranslation();
  return (
    <section style={{ padding: '22px', borderTop: '1px solid rgba(120,100,70,0.28)' }}>
      <div style={{ fontFamily: "'Bricolage Grotesque',sans-serif", fontWeight: 700, fontSize: 13, color: '#C0291F', marginBottom: 8 }}>{num}</div>
      <h2 {...ed(titleKey)} style={{ margin: '0 0 12px', fontFamily: "'Bricolage Grotesque',sans-serif", fontWeight: 700, fontSize: 21, lineHeight: 1.25 }}>{t(titleKey)}</h2>
      <div style={{ fontSize: 15, lineHeight: 1.7, color: '#4d463d' }}>{children}</div>
    </section>
  );
};

// Listen: jeder Punkt hat eine eigene Kennung (<liste>.<n>), gleiche Kennungen wie die Desktop-Seite.
const Dashes = ({ listKey }) => {
  const { t } = useTranslation();
  const items = t(listKey, { returnObjects: true });
  if (!Array.isArray(items)) return <p style={{ margin: 0 }} {...ed(listKey)}>{items}</p>;
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 9 }}>
      {items.map((item, i) => (
        <div key={i} style={{ display: 'flex', gap: 11, lineHeight: 1.5 }}>
          <span style={{ color: '#C0291F', fontWeight: 700, flexShrink: 0 }}>—</span>
          <span {...ed(`${listKey}.${i}`)}>{item}</span>
        </div>
      ))}
    </div>
  );
};

export default function MobilePrivacy() {
  const { t } = useTranslation();
  usePageMeta('privacy');
  const extra = textParagraphs(t('privacy.extra.text'));

  return (
    <MobileLayout>
      <section className="m-hero">
        <span className="m-kicker" {...ed('privacy.eyebrow')}>{t('privacy.eyebrow')}</span>
        <h1 {...ed('privacy.title')} style={{ fontSize: 34, lineHeight: 1 }}>{t('privacy.title')}</h1>
        <p {...ed('privacy.description')} style={{ marginBottom: 16 }}>{t('privacy.description')}</p>
        <span style={{ display: 'inline-block', fontSize: 12, fontWeight: 600, color: '#857A6E', border: '1px solid rgba(120,100,70,0.3)', padding: '7px 14px', borderRadius: 999 }}>
          <span {...ed('privacy.last_updated')}>{t('privacy.last_updated')}</span>: <span {...ed('privacy.last_updated_date')}>{t('privacy.last_updated_date')}</span>
        </span>
      </section>

      <Section num="01" titleKey="privacy.controller.title">
        <div {...ed('privacy.controller.name')} style={{ fontWeight: 600, color: '#26211C' }}>{t('privacy.controller.name')}</div>
        <div {...ed('privacy.controller.address')}>{t('privacy.controller.address')}</div>
        <div {...ed('privacy.controller.contact')}>{t('privacy.controller.contact')}</div>
        <div {...ed('privacy.controller.representative')}>{t('privacy.controller.representative')}</div>
      </Section>

      <Section num="02" titleKey="privacy.data_types.title"><Dashes listKey="privacy.data_types.list" /></Section>
      <Section num="03" titleKey="privacy.legal_basis.title"><Dashes listKey="privacy.legal_basis.list" /></Section>
      <Section num="04" titleKey="privacy.rights.title"><Dashes listKey="privacy.rights.list" /></Section>

      <Section num="05" titleKey="privacy.processing.title">
        {PRIVACY_PROCESSING_KEYS.map(key => (
          <div key={key} style={{ marginBottom: 20 }}>
            <h3 {...ed(`privacy.processing.${key}.title`)} style={{ margin: '0 0 6px', fontFamily: "'Bricolage Grotesque',sans-serif", fontWeight: 700, fontSize: 16, color: '#26211C' }}>{t(`privacy.processing.${key}.title`)}</h3>
            <p {...ed(`privacy.processing.${key}.text`)} style={{ margin: 0 }}>{t(`privacy.processing.${key}.text`)}</p>
          </div>
        ))}
      </Section>

      <Section num="06" titleKey="privacy.storage.title"><Dashes listKey="privacy.storage.list" /></Section>

      <Section num="07" titleKey="privacy.contact.title">
        <div {...ed('privacy.contact.dpo')}>{t('privacy.contact.dpo')}</div>
        <div {...ed('privacy.contact.email')}>{t('privacy.contact.email')}</div>
        <div {...ed('privacy.contact.deletion')}>{t('privacy.contact.deletion')}</div>
      </Section>

      {extra.length > 0 && (
        <Section num="+" titleKey="privacy.extra.title">
          <div {...ed('privacy.extra.text', 'paragraphs')}>
            {extra.map((p, i) => <p key={i} style={{ margin: '0 0 8px' }}>{p}</p>)}
          </div>
        </Section>
      )}

      <section style={{ padding: '0 22px' }}>
        <div className="m-red m-red-radius" style={{ padding: '28px 24px', marginTop: 22 }}>
          <h2 {...ed('privacy.contact_us.title')} style={{ margin: '0 0 12px', fontFamily: "'Bricolage Grotesque',sans-serif", fontWeight: 700, fontSize: 23, letterSpacing: '-0.01em' }}>
            {t('privacy.contact_us.title')}
          </h2>
          <p {...ed('privacy.contact_us.description')} style={{ margin: '0 0 18px', fontSize: 15, lineHeight: 1.55, color: 'rgba(255,255,255,0.9)' }}>
            {t('privacy.contact_us.description')}
          </p>
          <a
            href={`mailto:${t('privacy.contact_us.email.address')}?subject=${encodeURIComponent(t('privacy.contact_us.subject.text'))}`}
            className="m-btn m-btn-white"
          >
            <span {...ed('privacy.contact_us.button')}>{t('privacy.contact_us.button')}</span> →
          </a>
        </div>
      </section>
    </MobileLayout>
  );
}
